import React, { useRef } from 'react';
import './Tooltip.scss';

interface TooltipProps {
  children: React.ReactNode;
  text: string;
}

//If using Tooltip with an LMDS icon, you must set the "title" attribute to an empty string in the icon props

const Tooltip = (props: TooltipProps) => {
  return props?.text ? (
    <div className="tooltip-wrapper">
      {props.children}
      <span className="tooltiptext">{props.text}</span>
    </div>
  ) : props?.children ? (
    <div>{props.children}</div>
  ) : (
    <></>
  );
};

function OverflowTooltip(props: TooltipProps) {
  const cellRef = useRef<HTMLDivElement>(null);

  const handleMouseOver = () => {
    const el = cellRef.current;
    if (el) {
      const span: HTMLElement | null = el.querySelector('.tooltiptext');
      const div = el.querySelector('div');
      if (div && span && div.scrollWidth > div.clientWidth) {
        span.hidden = false;
      } else {
        if (span) {
          span.hidden = true;
        }
      }
    }
  };

  const handleMouseOut = () => {
    const el = cellRef.current;
    if (el) {
      const span: HTMLElement | null = el.querySelector('.tooltiptext');
      if (span) {
        span.hidden = true;
      }
    }
  };

  return (
    <div
      ref={cellRef}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
      className="tooltip-wrapper overflow-text"
    >
      <span hidden className="tooltiptext">
        {props.text}
      </span>
      {props.children}
    </div>
  );
}

export { Tooltip, OverflowTooltip };
